// Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See LICENSE.txt for license information.

export const NotificationLevel = {
    DEFAULT: 'default' as const,
    ALL: 'all' as const,
    MENTION: 'mention' as const,
    NONE: 'none' as const,
};

export const MarkUnread = {
    ALL: 'all',
    MENTION: 'mention',
};
